/* import __COLOCATED_TEMPLATE__ from './timestamp.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type ConversationStreamSettings from 'embercom/services/conversation-stream-settings';

interface Args {
  time: any;
}

interface Signature {
  Args: Args;
}

export default class TimestampComponent extends Component<Signature> {
  @service declare conversationStreamSettings: ConversationStreamSettings;

  get isCustomerTimezoneEnabled(): boolean {
    return this.conversationStreamSettings.isCustomerTimezoneEnabled;
  }

  get customerTimezone(): string | undefined {
    return this.conversationStreamSettings.effectiveCustomerTimezone;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::PartGroups::Timestamp': typeof TimestampComponent;
    'inbox2/conversation-stream/part-groups/timestamp': typeof TimestampComponent;
  }
}
